import React, { useEffect } from "react";
import { handleModalCloseOnEscape } from "../../lib/utility";
import { createPortal } from "react-dom";

const Modal = ({
  show,
  overlayColor,
  close,
  justify = "right",
  width = 500,
  height,
  maxHeight,
  overflow = "hidden",
  containerClassName,
  centerOnMobile = false,
  closeOnCancel = false,
  closeOnOutsideClick = false,
  zIndex = 50000,
  children,
}) => {
  function handleClose(e) {
    handleModalCloseOnEscape(e, close);
  }

  useEffect(() => {
    const handleKeyUp = (e) => {
      if (e.key === "Escape") {
        const datePickerPopup = document.querySelector(".rs-picker-popup");
        const isPopupVisible =
          datePickerPopup &&
          window.getComputedStyle(datePickerPopup).display !== "none" &&
          window.getComputedStyle(datePickerPopup).visibility !== "hidden";

        if (isPopupVisible) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }

        handleClose(e);
      }
    };

    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  useEffect(() => {
    if (show) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (show)
    return createPortal(
      <div
        className={["modal-portal-wrapper", centerOnMobile ? "mobCenter" : ""].filter(Boolean).join(" ")}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          right: 0,
          bottom: 0,
          height: "100dvh",
          zIndex: zIndex,
          display: "flex",
          justifyContent: justify,
          ...(justify === "center" ? { alignItems: "center" } : {}),
        }}
      >
        <div
          className="overlay"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            backgroundColor: overlayColor ?? "#00000085",
            backdropFilter: "blur(2px)",
            zIndex: zIndex + 1,
          }}
          onClick={() => {
            if (closeOnOutsideClick && typeof close === "function") {
              close();
            }
          }}
        ></div>
        <div
          className={["modal-container", containerClassName]
            .filter(Boolean)
            .join(" ")}
          style={{
            maxHeight: maxHeight ?? (justify === "center" ? "90vh" : "100%"),
            ...(height ? { height } : {}),
            zIndex: zIndex + 2,
            position: "relative",
            minWidth: `min(90vw, ${width}px)`,
            width: width,
            ...(justify === "center"
              ? { borderRadius: "16px", overflow: overflow }
              : { minHeight: "100%" }),
            maxWidth: "90vw",
          }}
        >
          {children}
        </div>
      </div>,
      document.body
    );
};

export default Modal;
